import { render, staticRenderFns } from "./todoTypeModal.vue?vue&type=template&id=56e122d3&scoped=true&"
import script from "./todoTypeModal.vue?vue&type=script&lang=ts&"
export * from "./todoTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./todoTypeModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./todoTypeModal.vue?vue&type=style&index=1&id=56e122d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e122d3",
  null
  
)

export default component.exports